// AI туслах — бүх layout-д (админ, багш /t, зөвлөх /c) баруун талд нээгддэг чат. Одоогийн хуудсыг мэднэ (utils/aiBus),
// Excel/CSV/PDF/зураг хавсаргана. AI өөрчлөлтийг САНАЛ болгоно → карт дээр «Батлах» дарвал хадгалагдаж, хуудас шууд шинэчлэгдэнэ;
// «Буцаах»-аар өмнөх утгад нь оруулна. Хүлээгдэж буй саналыг хуудас (жишээ нь багшийн дүнгийн хүснэгт) шараар тодруулна.
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Input, Select, Tag, message } from "antd";
import * as XLSX from "xlsx";
import { instance } from "utils/axios";
import { Answer } from "modules/admin/ai";
import { emitAiChanged, getAiContext, setAiPending, useAiModel } from "utils/aiBus";
import { buildFile, FORMAT_LABEL } from "./files";

const W = 420;
// Pin — самбар баруун талд бэхлэгдэж хуудсыг шахна (ширээний дэлгэц), дахин ачаалахад нээлттэй хэвээр; pin-гүй бол хуудсан дээгүүр гарна
const PIN_KEY = "aiPanelPinned";
const readPin = () => { try { return localStorage.getItem(PIN_KEY) === "1"; } catch (e) { return false; } };
const CONV_KEY = "aiConversation";
const readConv = () => { try { return Number(localStorage.getItem(CONV_KEY)) || null; } catch (e) { return null; } };
const ago = (d) => { const m = Math.round((Date.now() - new Date(d)) / 60000); return m < 60 ? `${m} мин` : m < 1440 ? `${Math.round(m / 60)} цаг` : `${Math.round(m / 1440)} өдөр`; };
const HIDDEN = /^\/(ai|m\/ai|choose|login)(\/|$)/;
const ACCEPT = ".xlsx,.xls,.csv,.pdf,.png,.jpg,.jpeg,.webp";
const EXAMPLES = [
  "Энэ ангийн дүнгээс сул байгаа сурагчдыг гарга",
  "Энэ ангид 10 асуулттай онлайн тест бэлд",
  "Энэ сэдвээр 10 слайдтай хичээлийн презентаци хийж өг",
  "30 дасгалтай ажлын хуудсыг Word файлаар бэлд",
];
const Icon = ({ d, size = 18 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{d}</svg>;
const SPARK = <><path d="M12 3l1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9z" /><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z" /></>;
const CLIP = <path d="M21 12.5l-8.6 8.6a5 5 0 0 1-7.1-7.1l8.6-8.6a3.3 3.3 0 0 1 4.7 4.7l-8.6 8.6a1.7 1.7 0 0 1-2.4-2.4l7.9-7.9" />;
const SEND = <><path d="M22 2L11 13" /><path d="M22 2l-7 20-4-9-9-4z" /></>;
const PLUS = <><path d="M12 5v14" /><path d="M5 12h14" /></>;
const CLOSE = <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>;
const HISTORY = <><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5" /><path d="M12 7v5l3 2" /></>;
const PIN = <><path d="M12 17v5" /><path d="M9 10.8V5h6v5.8l2.4 2.4a1 1 0 0 1-.7 1.8H7.3a1 1 0 0 1-.7-1.8z" /><path d="M8 5h8" /></>;
const BTN = "h-8 px-3.5 rounded-full text-[13px] font-semibold inline-flex items-center justify-center leading-none cursor-pointer disabled:opacity-50 disabled:cursor-default transition";
const errOf = (e) => e?.response?.data?.error || "Алдаа гарлаа";
const BL = { good: "Сайн", mid: "Дунд", poor: "Муу" };
const show = (v) => (v == null || v === "" ? "—" : BL[v] || String(v));

// Файл → AI-д илгээх хэлбэр: хүснэгт текстээр (CSV), PDF/зураг base64
function readFile(f) {
  return new Promise((ok, no) => {
    if (f.size > 10 * 1024 * 1024) return no(new Error(`«${f.name}» 10MB-аас их`));
    const r = new FileReader();
    if (/\.(xlsx|xls|csv)$/i.test(f.name)) {
      r.onload = () => {
        try {
          const wb = XLSX.read(r.result, { type: "array" });
          const text = wb.SheetNames.slice(0, 5).map((n) => `## ${n}\n${XLSX.utils.sheet_to_csv(wb.Sheets[n], { blankrows: false })}`).join("\n\n");
          ok({ name: f.name, type: "text/csv", text: text.slice(0, 120000) });
        } catch (e) { no(new Error(`«${f.name}» уншиж чадсангүй`)); }
      };
      r.readAsArrayBuffer(f);
    } else {
      r.onload = () => ok({ name: f.name, type: f.type || (/\.pdf$/i.test(f.name) ? "application/pdf" : "image/png"), data: String(r.result).split(",")[1] });
      r.readAsDataURL(f);
    }
    r.onerror = () => no(new Error(`«${f.name}» уншиж чадсангүй`));
  });
}

// AI-ийн үүсгэсэн файл (create_file) — дарахад хөтөч дээр үүсч татагдана
function FileCard({ a }) {
  const [busy, setBusy] = useState(false);
  const d = a.data || {};
  const get = () => {
    setBusy(true);
    Promise.resolve().then(() => buildFile(d)).catch((e) => message.error(e.message || "Файл үүсгэж чадсангүй")).then(() => setBusy(false));
  };
  const info = d.slides ? `${d.slides.length} слайд` : d.sheets ? `${d.sheets.length} хуудас` : d.format === "pdf" ? "Хэвлэх цонхонд «Save as PDF»" : null;
  return (
    <div className="rounded-2xl border border-solid border-[#e5d8f5] bg-white p-3 flex items-center gap-3">
      <div className="w-10 h-10 shrink-0 rounded-xl bg-[#f3eeff] text-[#5c1090] flex items-center justify-center text-[11px] font-bold uppercase">{d.format}</div>
      <div className="flex-1 min-w-0">
        <div className="text-[13px] font-semibold text-[#2d1b4e] truncate">{a.title}</div>
        <div className="text-[11px] text-gray-500">{FORMAT_LABEL[d.format] || d.format}{info ? ` · ${info}` : ""}</div>
      </div>
      <button type="button" disabled={busy} onClick={get} className={`${BTN} border-0 bg-[#5c1090] text-white hover:bg-[#4a0d74]`}>{busy ? "…" : d.format === "pdf" ? "PDF нээх" : "Татах"}</button>
    </div>
  );
}

export function ActionCard({ a, onChange }) {
  const [busy, setBusy] = useState(null);
  const [all, setAll] = useState(false);
  if (a.kind === "file") return <FileCard a={a} />;
  const run = (op) => {
    setBusy(op);
    instance({ method: "post", url: `/ai/actions/${a.id}/${op}`, noMessage: true })
      .then(({ data }) => {
        onChange(data.action);
        if (op !== "cancel") emitAiChanged({ courseId: a.courseId, groupId: a.groupId });
        message.success(op === "apply" ? "Хадгалагдлаа" : op === "undo" ? "Буцаалаа" : "Цуцаллаа");
      })
      .catch((e) => message.error(errOf(e)))
      .then(() => setBusy(null));
  };
  const rows = (a.items || []).filter((x) => show(x.cur) !== show(x.value));
  const same = (a.items || []).length - rows.length;
  const visible = all ? rows : rows.slice(0, 8);
  const status = {
    applied: <Tag color="green">Хадгалагдсан</Tag>, cancelled: <Tag>Цуцалсан</Tag>, undone: <Tag color="blue">Буцаасан</Tag>, failed: <Tag color="red">Алдаа</Tag>,
  }[a.status];
  return (
    <div className={`rounded-2xl border ${a.status === "proposed" ? "border-[#f2cd30] bg-[#fffbea]" : "border-[#efe8fa] bg-white"} p-3.5 flex flex-col gap-2.5`}>
      <div className="flex items-start gap-2">
        <div className="text-[13px] font-semibold text-[#2d1b4e] flex-1">{a.title}</div>
        {status}
      </div>
      {a.items && (
        <div className="overflow-x-auto">
          <table className="w-full text-[12px] border-collapse">
            <thead><tr className="text-left text-gray-500"><th className="font-medium py-1 pr-2">Сурагч</th><th className="font-medium py-1 pr-2">Одоо</th><th className="font-medium py-1">Санал</th></tr></thead>
            <tbody>
              {visible.map((x) => (
                <tr key={x.studentId} className="border-t border-black/5 align-top">
                  <td className="py-1 pr-2 whitespace-nowrap">{x.name}</td>
                  <td className="py-1 pr-2 text-gray-500">{show(x.cur)}</td>
                  <td className="py-1 font-semibold text-[#5c1090] whitespace-pre-wrap">{show(x.value)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length > 8 && <button type="button" className="text-[12px] text-[#5c1090] underline mt-1 border-0 bg-transparent p-0 cursor-pointer" onClick={() => setAll(!all)}>{all ? "Хураах" : `Бүгдийг харах (${rows.length})`}</button>}
          {same > 0 && <div className="text-[11px] text-gray-500 mt-1">{same} сурагчийн утга өөрчлөгдөхгүй</div>}
        </div>
      )}
      {a.kind === "item" && a.data && (
        <div className="text-[12px] text-gray-700 flex flex-col gap-1">
          {a.data.description && <div className="whitespace-pre-wrap line-clamp-4">{a.data.description}</div>}
          {Array.isArray(a.data.questions) && <div>{a.data.questions.length} асуулт{a.data.timeLimitMin ? ` · ${a.data.timeLimitMin} мин` : ""}</div>}
          {Array.isArray(a.data.questions) && <ol className="pl-4 m-0 list-decimal">{a.data.questions.slice(0, all ? 50 : 3).map((q, i) => <li key={i}>{q.text}</li>)}</ol>}
          {Array.isArray(a.data.questions) && a.data.questions.length > 3 && <button type="button" className="self-start text-[12px] text-[#5c1090] underline border-0 bg-transparent p-0 cursor-pointer" onClick={() => setAll(!all)}>{all ? "Хураах" : "Бүх асуулт"}</button>}
          <div className="text-[11px] text-gray-500">Ноорог болж үүснэ — «Шинээр нэмэх» дотроос шалгаад нийтэлнэ.</div>
        </div>
      )}
      {a.error && <div className="text-[12px] text-red-600">{a.error}</div>}
      {a.status === "proposed" && (
        <div className="flex gap-2 flex-wrap pt-0.5">
          <button type="button" disabled={!!busy} onClick={() => run("apply")} className={`${BTN} border-0 bg-[#5c1090] text-white hover:bg-[#4a0d74]`}>{busy === "apply" ? "Хадгалж байна…" : `Батлах${a.items ? ` (${rows.length})` : ""}`}</button>
          <button type="button" disabled={!!busy} onClick={() => run("cancel")} className={`${BTN} bg-white border border-solid border-[#e5d8f5] text-[#4a0d74] hover:bg-[#faf7ff]`}>Цуцлах</button>
        </div>
      )}
      {a.status === "applied" && <button type="button" disabled={!!busy} onClick={() => run("undo")} className={`${BTN} self-start bg-white border border-solid border-[#e5d8f5] text-[#4a0d74] hover:bg-[#faf7ff]`}>{busy === "undo" ? "Буцааж байна…" : "Буцаах"}</button>}
    </div>
  );
}

export default function AiPanel() {
  const location = useLocation();
  const [pinned, setPinnedState] = useState(readPin);
  const [open, setOpenState] = useState(readPin);
  const setPinned = (v) => { setPinnedState(v); try { localStorage.setItem(PIN_KEY, v ? "1" : "0"); } catch (e) { /* хувийн горим */ } };
  const setOpen = setOpenState;
  const [thread, setThread] = useState([]);
  // Яриа: ID-г хадгалж, дахин ачаалахад сэргээнэ; өмнөх яриаг сервер бүтнээр нь AI-д дамжуулна
  const [convId, setConvIdState] = useState(readConv);
  const setConvId = (v) => { setConvIdState(v); try { if (v) localStorage.setItem(CONV_KEY, String(v)); else localStorage.removeItem(CONV_KEY); } catch (e) { /* хувийн горим */ } };
  const [convs, setConvs] = useState(null);
  const [q, setQ] = useState("");
  const [files, setFiles] = useState([]);
  const [sending, setSending] = useState(false);
  const [tick, setTick] = useState(0);
  const end = useRef(null);
  const fileRef = useRef(null);
  const panelRef = useRef(null);
  const { models, model, setModel } = useAiModel(instance);
  const pending = thread.find((t) => t.status === "running");
  const hidden = HIDDEN.test(location.pathname);

  // Pin хийсэн бол ширээний дэлгэцэнд хуудсыг шахна (хүснэгт харагдсаар)
  const docked = open && pinned && !hidden;
  useEffect(() => {
    document.body.classList.toggle("ai-docked", docked);
    return () => document.body.classList.remove("ai-docked");
  }, [docked]);
  useEffect(() => { end.current?.scrollIntoView({ behavior: "smooth", block: "end" }); }, [thread.length, pending?.status, open]);
  // Хүлээгдэж буй саналыг хуудсуудад
  useEffect(() => { setAiPending(thread.flatMap((t) => (t.actions || []).filter((a) => a.status === "proposed"))); }, [thread]);

  const loadConv = (id) => instance({ method: "get", url: `/ai/conversations/${id}`, noMessage: true })
    .then(({ data }) => { setThread(data.logs); setConvId(data.id); setConvs(null); })
    .catch(() => setConvId(null));
  useEffect(() => { if (convId) loadConv(convId); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const newChat = () => { setThread([]); setConvId(null); setConvs(null); };
  const toggleConvs = () => {
    if (convs) return setConvs(null);
    instance({ method: "get", url: "/ai/conversations", noMessage: true }).then(({ data }) => setConvs(data)).catch((e) => message.error(errOf(e)));
  };

  useEffect(() => {
    if (!pending) return undefined;
    const t = setInterval(() => {
      setTick((x) => x + 1);
      instance({ method: "get", url: `/ai/logs/${pending.id}`, noMessage: true }).then(({ data }) => {
        if (data.status === "running") return;
        setThread((th) => th.map((x) => (x.id === data.id ? data : x)));
      }).catch(() => {});
    }, 2500);
    return () => clearInterval(t);
  }, [pending?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const ask = (text) => {
    const question = (text ?? q).trim();
    if (question.length < 3 || pending || sending) return;
    setSending(true);
    const context = { ...(getAiContext() || {}), path: location.pathname, title: document.title };
    instance({ method: "post", url: "/ai/ask", data: { question, conversationId: convId, context, files, model }, noMessage: true })
      .then(({ data }) => {
        setConvId(data.conversationId);
        setThread((th) => [...th, { id: data.id, question: files.length ? `${question}\n📎 ${files.map((f) => f.name).join(", ")}` : question, status: "running" }]);
        setQ(""); setFiles([]); setTick(0);
      })
      .catch((e) => message.error(errOf(e)))
      .then(() => setSending(false));
  };
  const attach = (list) => Promise.all([...list].slice(0, 5 - files.length).map(readFile))
    .then((xs) => setFiles((f) => [...f, ...xs]))
    .catch((e) => message.error(e.message));
  const patchAction = (logId, a) => setThread((th) => th.map((t) => (t.id === logId ? { ...t, actions: t.actions.map((x) => (x.id === a.id ? a : x)) } : t)));

  if (hidden) return null;
  const ctx = getAiContext();
  const canSend = !pending && !sending && q.trim().length >= 3;
  return (
    <>
      <style>{`
        @media (min-width: 1024px) {
          body.ai-docked #root { margin-right: ${W}px; }
          /* Админы layout: толгой fixed (right: 0), main 100vw — самбарын өргөнөөр багасгана */
          body.ai-docked #layout > header { right: ${W}px; }
          body.ai-docked #layout > main { width: calc(100vw - var(--sidebar-width) - ${W}px); }
          body.ai-docked #layout.layout-top > main { width: calc(100vw - ${W}px); }
        }
        .ai-model.power-select .power-select-selector { border-radius: 999px !important; border-color: #e5d8f5 !important; background: #faf7ff !important; height: 30px !important; padding: 0 10px !important; align-items: center; }
        .ai-model.power-select-focused .power-select-selector, .ai-model.power-select:hover .power-select-selector { border-color: #5c1090 !important; box-shadow: 0 0 0 2px rgba(92,16,144,.1) !important; }
        .ai-model-pop .power-select-item-option-selected { background: #f3eeff !important; }
        .ai-model.power-select .power-select-selection-item { font-size: 12px; font-weight: 600; color: #4a0d74; line-height: 28px !important; }
        @keyframes ai-dot { 0%, 80%, 100% { opacity: .25 } 40% { opacity: 1 } }
        .ai-dot { width: 6px; height: 6px; border-radius: 999px; background: #5c1090; animation: ai-dot 1.2s infinite; }
      `}</style>
      {!open && (
        <button type="button" onClick={() => setOpen(true)} aria-label="AI туслах нээх"
          className="fixed right-4 z-[1001] h-12 pl-4 pr-5 rounded-full border-0 cursor-pointer bg-[#5c1090] text-white shadow-lg inline-flex items-center gap-2 text-[14px] font-semibold leading-none hover:bg-[#4a0d74] bottom-[84px] md:bottom-6">
          <Icon d={SPARK} />AI туслах
        </button>
      )}
      {open && (
        <aside ref={panelRef} aria-label="AI туслах" className={`fixed top-0 right-0 bottom-0 z-[1001] bg-white border-0 border-l border-solid border-[#e5d8f5] ${docked ? "lg:shadow-none" : "shadow-2xl"} flex flex-col`} style={{ width: `min(${W}px, 100vw)` }}>
          <header className="h-14 shrink-0 px-3 border-b border-[#f3eeff] flex items-center gap-2">
            <div className="w-8 h-8 shrink-0 rounded-[10px] bg-[#f3eeff] text-[#5c1090] flex items-center justify-center"><Icon d={SPARK} size={17} /></div>
            <div className="flex-1 min-w-0 leading-tight">
              <div className="font-bold text-[15px] text-[#2d1b4e]">AI туслах</div>
              <div className="text-[12px] text-gray-500 truncate">{ctx?.class ? `${ctx.class}${ctx.term ? ` · ${ctx.term}` : ""}` : "Танд туслахад бэлэн"}</div>
            </div>
            {models && (
              <Select value={model} onChange={setModel} aria-label="AI загвар" className="ai-model shrink-0" bordered
                dropdownMatchSelectWidth={false} optionLabelProp="label" placement="bottomRight" dropdownClassName="ai-model-pop" getPopupContainer={() => panelRef.current || document.body}>
                {models.map((m) => (
                  <Select.Option key={m.id} value={m.id} label={m.label}>
                    <div className="py-0.5">
                      <div className="font-semibold text-[13px]">{m.label}</div>
                      <div className="text-[11px] text-gray-500">{m.note}</div>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            )}
            <button type="button" aria-label="Өмнөх яриа" title="Өмнөх яриа" aria-pressed={!!convs} disabled={!!pending} onClick={toggleConvs}
              className={`w-9 h-9 shrink-0 rounded-lg border-0 cursor-pointer inline-flex items-center justify-center disabled:opacity-30 disabled:cursor-default ${convs ? "bg-[#f3eeff] text-[#5c1090]" : "bg-transparent text-gray-500 hover:bg-gray-100"}`}>
              <Icon d={HISTORY} size={18} />
            </button>
            <button type="button" aria-label="Шинэ чат" title="Шинэ чат" disabled={!!pending || !thread.length} onClick={newChat}
              className="w-9 h-9 shrink-0 rounded-lg border-0 bg-transparent cursor-pointer text-gray-500 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-default disabled:hover:bg-transparent inline-flex items-center justify-center">
              <Icon d={PLUS} size={18} />
            </button>
            <button type="button" aria-label={pinned ? "Pin болиулах" : "Баруун талд pin хийх"} title={pinned ? "Pin болиулах" : "Баруун талд pin хийх"} aria-pressed={pinned} onClick={() => setPinned(!pinned)}
              className={`hidden lg:inline-flex w-9 h-9 shrink-0 rounded-lg border-0 cursor-pointer items-center justify-center ${pinned ? "bg-[#f3eeff] text-[#5c1090]" : "bg-transparent text-gray-500 hover:bg-gray-100"}`}>
              <Icon d={PIN} size={17} />
            </button>
            <button type="button" aria-label="Хаах" title="Хаах" onClick={() => setOpen(false)} className="w-9 h-9 shrink-0 rounded-lg border-0 bg-transparent cursor-pointer text-gray-500 hover:bg-gray-100 inline-flex items-center justify-center">
              <Icon d={CLOSE} size={18} />
            </button>
          </header>

          <div className="flex-1 overflow-y-auto px-4 py-4 flex flex-col gap-5 bg-[#fcfbff]">
            {convs && (
              <nav aria-label="Өмнөх яриа" className="flex flex-col gap-1.5">
                <div className="text-[12px] font-semibold text-gray-500 px-1">Өмнөх яриа</div>
                {!convs.length && <div className="text-[13px] text-gray-500 px-1">Хадгалсан яриа алга.</div>}
                {convs.map((c) => (
                  <button key={c.id} type="button" onClick={() => loadConv(c.id)} aria-current={c.id === convId ? "true" : undefined}
                    className={`text-left rounded-xl border border-solid cursor-pointer px-3.5 py-2.5 ${c.id === convId ? "border-[#5c1090] bg-[#faf7ff]" : "border-[#e5d8f5] bg-white hover:border-[#5c1090]"}`}>
                    <div className="text-[13px] font-semibold text-[#2d1b4e] truncate">{c.title}</div>
                    <div className="text-[11px] text-gray-500">{c.n} асуулт · {ago(c.lastAt)}-ийн өмнө</div>
                  </button>
                ))}
              </nav>
            )}
            {!convs && !thread.length && (
              <div className="flex flex-col gap-3 pt-6">
                <div className="text-center">
                  <div className="mx-auto w-12 h-12 rounded-2xl bg-[#f3eeff] text-[#5c1090] flex items-center justify-center mb-2"><Icon d={SPARK} size={22} /></div>
                  <div className="font-semibold text-[15px] text-[#2d1b4e]">Юу хийх вэ?</div>
                  <div className="text-[12px] text-gray-500 mt-0.5">Ямар ч хэлээр бичээрэй. Excel, PDF, зураг хавсаргаж, Word, PDF, слайд, Excel файл авч болно.</div>
                </div>
                <div className="flex flex-col gap-2 mt-2">
                  {EXAMPLES.map((e) => (
                    <button key={e} type="button" onClick={() => setQ(e)}
                      className="text-left text-[13px] leading-snug rounded-xl border border-solid border-[#e5d8f5] cursor-pointer bg-white hover:border-[#5c1090] hover:bg-[#faf7ff] px-3.5 py-2.5 text-[#2d1b4e]">{e}</button>
                  ))}
                </div>
              </div>
            )}
            {!convs && thread.map((t) => (
              <div key={t.id} className="flex flex-col gap-2.5">
                <div className="self-end max-w-[86%] rounded-2xl rounded-br-md bg-[#5c1090] text-white px-3.5 py-2 text-[14px] leading-relaxed whitespace-pre-wrap">{t.question}</div>
                {t.status === "running" ? (
                  <div className="self-start inline-flex items-center gap-2 rounded-2xl rounded-bl-md bg-white border border-[#efe8fa] px-3.5 py-2.5 text-[13px] text-gray-500">
                    <span className="ai-dot" /><span className="ai-dot" style={{ animationDelay: ".2s" }} /><span className="ai-dot" style={{ animationDelay: ".4s" }} />
                    <span className="ml-1">{Math.round(tick * 2.5)}с</span>
                  </div>
                ) : (
                  <>
                    <div className="self-start w-full rounded-2xl rounded-bl-md bg-white border border-[#efe8fa] px-3.5 py-3"><Answer r={t} /></div>
                    {(t.actions || []).map((a) => <ActionCard key={a.id} a={a} onChange={(x) => patchAction(t.id, x)} />)}
                  </>
                )}
              </div>
            ))}
            <div ref={end} />
          </div>

          <div className="shrink-0 p-3 border-t border-[#f3eeff] bg-white"
            onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); attach(e.dataTransfer.files); }}>
            <div className="ai-composer rounded-2xl border border-[#e5d8f5] bg-white focus-within:border-[#5c1090] focus-within:ring-2 focus-within:ring-[#5c1090]/10 transition">
              {files.length > 0 && (
                <div className="flex flex-wrap gap-1.5 px-3 pt-2.5">
                  {files.map((f, i) => (
                    <span key={i} className="inline-flex items-center gap-1 h-7 pl-2.5 pr-1 rounded-full bg-[#f3eeff] text-[12px] text-[#4a0d74] max-w-full">
                      <span className="truncate max-w-[220px]">{f.name}</span>
                      <button type="button" aria-label={`${f.name} хасах`} onClick={() => setFiles((x) => x.filter((_, j) => j !== i))} className="w-5 h-5 rounded-full border-0 bg-transparent cursor-pointer text-[#4a0d74] hover:bg-white/70 inline-flex items-center justify-center"><Icon d={CLOSE} size={12} /></button>
                    </span>
                  ))}
                </div>
              )}
              <Input.TextArea value={q} onChange={(e) => setQ(e.target.value)} autoSize={{ minRows: 2, maxRows: 6 }} bordered={false} style={{ boxShadow: "none", background: "transparent", resize: "none", padding: "10px 12px 2px", fontSize: 14 }} maxLength={20000} aria-label="Асуулт"
                placeholder="Асуулт, даалгавраа бичнэ үү…"
                onPressEnter={(e) => { if (!e.shiftKey) { e.preventDefault(); ask(); } }} />
              <div className="flex items-center gap-2 px-2 pb-2">
                <input ref={fileRef} type="file" accept={ACCEPT} multiple hidden onChange={(e) => { attach(e.target.files); e.target.value = ""; }} />
                <button type="button" aria-label="Файл хавсаргах" title="Файл хавсаргах (Excel, PDF, зураг)" onClick={() => fileRef.current?.click()}
                  className="w-9 h-9 shrink-0 rounded-full border-0 bg-transparent cursor-pointer text-[#5c1090] hover:bg-[#f3eeff] inline-flex items-center justify-center"><Icon d={CLIP} size={18} /></button>
                <span className="flex-1 text-[11px] text-gray-400 truncate">Enter — илгээх · Shift+Enter — шинэ мөр</span>
                <button type="button" aria-label="Илгээх" onClick={() => ask()} disabled={!canSend}
                  className="w-9 h-9 shrink-0 rounded-full border-0 cursor-pointer bg-[#5c1090] text-white inline-flex items-center justify-center hover:bg-[#4a0d74] disabled:bg-[#e5d8f5] disabled:cursor-default transition">
                  {sending ? <span className="ai-dot !bg-white" /> : <Icon d={SEND} size={16} />}
                </button>
              </div>
            </div>
            <div className="text-[11px] text-gray-400 text-center mt-1.5">Таны эрхээр ажиллана · Системд Батлахаас өмнө юу ч хадгалагдахгүй</div>
          </div>
        </aside>
      )}
    </>
  );
}
